import './Newsletter.css';
import { useState } from 'react';
import { addtonewsletter } from '../../../api';

export default function Newsletter() {
  const [form, setForm] = useState({ firstName: '', lastName: '', email: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.email && form.firstName) {
      setSubmitted(true);
    }
    const formData = {email: form.email, firstName: form.firstName, lastName: form.lastName}
    await addtonewsletter(formData) ; 
  };



  return (
    <section id="newsletter" className="newsletter-section">
      <div className="container">
        <div className="newsletter-inner">
          <div className="newsletter-content">
            <span className="newsletter-eyebrow">Stay in the loop</span>
            <h2 className="section-title newsletter-title">
              Newsletter
            </h2>
            <p className="newsletter-desc">
              Get notified when new courses and content are released.
            </p>
            <div className="newsletter-promise">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
              <span>Maximum <strong>one email per month</strong> — no spam, ever.</span>
            </div>
            <div className="newsletter-promise">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
              <span>Unsubscribe at any time.</span>
            </div>
          </div>

          <div className="newsletter-form-wrap">
            {submitted ? (
              <div className="newsletter-success" role="alert">
                <div className="newsletter-success__icon">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                </div>
                <h3>You're subscribed!</h3>
                <p>Thanks, {form.firstName}. We'll be in touch — but not too often.</p>
              </div>
            ) : (
              <form className="newsletter-form" onSubmit={handleSubmit} noValidate>
                <div className="newsletter-form__row">
                  <div className="newsletter-form__field">
                    <label className="newsletter-form__label" htmlFor="nl-firstName">
                      First name <span aria-hidden="true">*</span>
                    </label>
                    <input
                      id="nl-firstName"
                      name="firstName"
                      type="text"
                      className="newsletter-form__input"
                      value={form.firstName}
                      onChange={handleChange}
                      placeholder="Rachel"
                      required
                      autoComplete="given-name"
                    />
                  </div>
                  <div className="newsletter-form__field">
                    <label className="newsletter-form__label" htmlFor="nl-lastName">
                      Last name
                    </label>
                    <input
                      id="nl-lastName"
                      name="lastName"
                      type="text"
                      className="newsletter-form__input"
                      value={form.lastName}
                      onChange={handleChange}
                      placeholder="Keen"
                      autoComplete="family-name"
                    />
                  </div>
                </div>

                <div className="newsletter-form__field">
                  <label className="newsletter-form__label" htmlFor="nl-email">
                    Email address <span aria-hidden="true">*</span>
                  </label>
                  <input
                    id="nl-email"
                    name="email"
                    type="email"
                    className="newsletter-form__input"
                    value={form.email}
                    onChange={handleChange}
                    placeholder="raye@example.com"
                    required
                    autoComplete="email"
                  />
                </div>

                <button type="submit" className="newsletter-form__submit">
                  Subscribe
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                    <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
                  </svg>
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
